/* eslint-disable */
import React from 'react'
import {Link} from 'react-router-dom'
import http from '../Interceptor/Interseptor'
import {Icon, message} from 'antd'
import Select from 'react-select'
import SinglePicker from '../BaseComponent/singlePicker'
import USER_MANAGE from '../BaseComponent/USERMANAGE'
import {withRouter} from 'react-router-dom'
import Loader from '../loaders/loader'
import jMoment from 'moment-jalali'
import InputMask from 'react-input-mask'
import moment from 'moment'
import JalaliUtils from 'material-ui-pickers-jalali-utils'
import {DatePicker, MuiPickersUtilsProvider} from 'material-ui-pickers'
jMoment.loadPersian({dialect: 'persian-modern', usePersianDigits: true})

class EditDriverCartStation extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      deliveryDate: null,
      cartStationId: '',
      driverId: '',
      drivers: [],
      cartStations: [],
      loading: false
    }
  }

  convertDigit = (string) => {
    return string
      .replace(/[\u0660-\u0669]/g, function(c) {
        return c.charCodeAt(0) - 0x0660
      })
      .replace(/[\u06f0-\u06f9]/g, function(c) {
        return c.charCodeAt(0) - 0x06f0
      })
  }

  submit(e) {
    e.preventDefault()
  }

  changeActivityDate = (deliveryDate) => {
    this.setState({deliveryDate})
  }

  componentDidMount() {
    this.setState({
      loading: true
    })
    Promise.all([this.getEntity(), this.getDrivers(), this.getCartStations()])
      .then((res) => {
        this.setState({
          loading: false
        })
        let getSelectedDriver = res[1].find((item) => +item.personId === +res[0].driver.personId)
        if (getSelectedDriver) {
          this.setState({
            driverId: getSelectedDriver
          })
        }
        let getSelectedCart = res[2].find((item) => item.id === res[0].cartStation.id)
        if (getSelectedCart) {
          this.setState({
            cartStationId: getSelectedCart
          })
        }
        this.setState({
          deliveryDate: res[0].deliveryDate
          // deliveryDate : this.convertDigit(jMoment(res[0].deliveryDate).format('jYYYY/jMM/jDD')),
        })
      })
      .catch(() => {
        this.setState({
          loading: false
        })
      })
  }

  getEntity = () => {
    let {id} = this.props.match.params
    return http.get(`cartStationDriver/${id}/get`, {}).then((res) => {
      if (res.data.error === null) {
        return res.data.object
      }
    })
  }

  getDrivers = () => {
    return http
      .get(`${USER_MANAGE.USER_MANAGE_LIST_DRIVER}`, {})
      .then((response) => {
        if (response.data.error == null) {
          var drivers = response.data.object
          for (let i = 0; i < drivers.length; i++) {
            drivers[i]['value'] = drivers[i].personId
            drivers[i]['label'] = drivers[i].personId + ' - ' + drivers[i].name
          }
          this.setState({
            drivers: response.data.object
          })
          return response.data.object
        }
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })
  }

  getCartStations = () => {
    return http
      .get(`cartStation/list`, {})
      .then((response) => {
        if (response.data.error == null) {
          var carts = response.data.object
          for (let i = 0; i < carts.length; i++) {
            carts[i]['value'] = carts[i].id
            carts[i]['label'] = carts[i].id + ' - ' + carts[i].title
          }
          this.setState({
            cartStations: response.data.object
          })
          return response.data.object
        }
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })
  }

  editCartStation() {
    let {id} = this.props.match.params
    let driverId = this.state.driverId === null || this.state.driverId === '' ? '' : this.state.driverId.personId
    let cartStation =
      this.state.cartStationId === null || this.state.cartStationId === '' ? '' : this.state.cartStationId.id
    let deliveryDate = this.state.deliveryDate
    if (driverId === '' || cartStation === '' || deliveryDate === '' || deliveryDate === null) {
      message.error('فیلدهای ستاره دار وارد شود')
    } else {
      let data = {
        deliveryDate:
          typeof deliveryDate === 'number'
            ? deliveryDate
            : moment(deliveryDate)
                .startOf('day')
                .unix() * 1000,
        driverId,
        cartStationId: cartStation
      }
      http.put(`cartStationDriver/${id}/update`, data, {}).then((res) => {
        if (res.data.error === null) {
          message.success('جایگاه رساننده با موفقیت ویرایش شد')
          setTimeout(() => {
            // window.location.assign('/driverCartStation/report')
          }, 3000)
        } else {
        }
      })
    }
  }

  selectedDriver = (driverId) => {
    this.setState({
      driverId
    })
  }

  selectCartStation = (cartStationId) => {
    this.setState({
      cartStationId
    })
  }

  onChange(e) {
    let value = e.target.value
    this.setState({
      deliveryDate: value
    })
  }

  epochFrom = (x) => {
    var jalaiDate = this.convertDigit(jMoment(x).format('jYYYY/jMM/jDD'))
    var concatDayMount = jalaiDate.split('/')
    var concatDate = concatDayMount[1] + concatDayMount[2]
    var constantDate = '0631'
    var n = concatDate.localeCompare(constantDate)

    let miladiDate = jMoment(x, 'jYYYY/jM/jD').format('YYYY/M/D')
    let from = miladiDate + ' ' + '00:00'
    let fromEpoch = moment.utc(from).valueOf()
    // return fromEpoch;
    if (n >= 0) {
      return fromEpoch - 3.5 * 3600 * 1000
    } else if (n < 0 && concatDate === '0101') {
      return fromEpoch - 3.5 * 3600 * 1000
    } else {
      return fromEpoch - 3.5 * 3600 * 1000
    }
  }

  beforeMaskedValueChangeFrom = (newState, oldState, userInput) => {
    var {value} = newState
    var selection = newState.selection
    var cursorPosition = selection ? selection.start : null

    // keep minus if entered by user
    if (value.endsWith('-') && userInput !== '-' && !this.state.value.endsWith('-')) {
      if (cursorPosition === value.length) {
        cursorPosition--
        selection = {start: cursorPosition, end: cursorPosition}
      }
      value = value.slice(0, -1)
    }

    return {
      value,
      selection
    }
  }

  date(props) {
    return <input className="form-control" {...props} />
  }

  handleDateChange = (deliveryDate) => {
    this.setState({
      deliveryDate
    })
  }

  render() {
    return (
      <div className="rtl printA4Page">
        <Loader show={this.state.loading} />
        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>توزیع</li>
            <li>جایگاه</li>
            <li>ویرایش جایگاه رساننده </li>
          </ul>
          <form className="verticalForm" onSubmit={this.submit.bind(this)}>
            <div className="headerVertical">
              <p>ویرایش جایگاه رساننده </p>
            </div>
            <div className="formComponent">
              <label className="font-weight-bold">
                تاریخ :<span className="requireFiled font-weight-bold">*</span>
              </label>
              <MuiPickersUtilsProvider utils={JalaliUtils} locale="fa">
                <DatePicker
                  inline
                  okLabel="تأیید"
                  autoOk={true}
                  leftArrowIcon={<Icon type="left" />}
                  rightArrowIcon={<Icon type="right" />}
                  cancelLabel="لغو"
                  labelFunc={(deliveryDate) => (deliveryDate == null ? '' : deliveryDate.format('jYYYY/jM/jDD'))}
                  value={this.state.deliveryDate}
                  id="deliveryDate"
                  onChange={this.handleDateChange}
                  TextFieldComponent={this.date}
                  readOnly
                />
              </MuiPickersUtilsProvider>
              {/*<SinglePicker*/}
              {/*    label ='تاریخ'*/}
              {/*    id = 'picker'*/}
              {/*    force*/}
              {/*    changeDate={this.changeActivityDate}*/}
              {/*/>*/}
            </div>
            {/*<div className='formComponent'>*/}
            {/*    <label className='font-weight-bold' htmlFor="ماهیت">تاریخ<span className='requireFiled'>*</span></label>*/}
            {/*    <InputMask*/}
            {/*        onChange={this.onChange.bind(this)}*/}
            {/*        placeholder='yyyy/mm/dd'*/}
            {/*        id='deliveryDate'*/}
            {/*        name='deliveryDate'*/}
            {/*        value={this.state.deliveryDate}*/}
            {/*        className='form-control'*/}
            {/*        mask="9999/99/99" maskChar={null}*/}
            {/*        beforeMaskedValueChange={this.beforeMaskedValueChangeFrom}*/}
            {/*    />*/}
            {/*</div>*/}
            <div className="formComponent">
              <label className="mb-2 mr-sm-2 font-weight-bold">
                رساننده
                <span className="requireFiled font-weight-bold">*</span>
              </label>
              <Select
                value={this.state.driverId}
                onChange={this.selectedDriver}
                options={this.state.drivers}
                isClearable={true}
                placeholder=""
              />
            </div>
            <div className="formComponent">
              <label className="mb-2 mr-sm-2 font-weight-bold">
                جایگاه
                <span className="requireFiled font-weight-bold">*</span>
              </label>
              <Select
                value={this.state.cartStationId}
                onChange={this.selectCartStation}
                options={this.state.cartStations}
                isClearable={true}
                placeholder=""
              />
            </div>

            <div className="formComponent selectComponent">
              <button className="btn btn-info btn-block jasperBtn" onClick={this.editCartStation.bind(this)}>
                ویرایش جایگاه رساننده
              </button>
              <p className="errorText" id="errorText" />
            </div>
          </form>
        </div>
      </div>
    )
  }
}
export default withRouter(EditDriverCartStation)
